import React, { useMemo, useRef, useState, useEffect } from "react";
import dayjs from "dayjs";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import Button from "../../../components/ui/Button/Button";
import { useEditor } from "../../../utils/hooks";
import { EditorContent } from "@tiptap/react";
import Editor from "../../../components/Editor";
import Modal from "../../../components/ui/Modal/Modal";
import {
  useAddterms,
  useUpdateterms,
} from "../../../api/inquiries/terms-condition/use-terms-condition";
import EditorViewer from "../../../components/EditorViewer";

const TermsConditions = (props) => {
  const {
    html,
    editMode,
    onEdit,
    onCancelEdit,
    type,
    id,
    updatedAt,
    onSubmit,
  } = props;
  const [isDisabled, setIsDisabled] = useState(false);
  const { mutate: addTerms } = useAddterms();
  const { mutate: updateTerms } = useUpdateterms();
  const quillRef = useRef(null);

  const parsedDelta = useMemo(() => {
    if (!html || html === "undefined") return { ops: [] };
    try {
      return JSON.parse(html);
    } catch (error) {
      return { ops: [] };
    }
  }, [html]);

  useEffect(() => {
    if (quillRef.current) {
      setIsDisabled(quillRef.current?.getLength() === 1);
    }
  }, [quillRef.current, editMode]);

  const onTextChange = (content) => {
    setIsDisabled(quillRef.current?.getLength() === 1);
  };

  const onEditSubmit = () => {
    onCancelEdit();
  };

  const handleSubmit = async () => {
    const title = () => {
      switch (type) {
        case 0:
          return "서비스 이용약관";
        case 1:
          return "전자지급 결제대행 서비스 이용약관";
        case 2:
          return "개인정보 이용 및 제3자 제공 동의서";
        case 3:
          return "환불 규정 안내";

        default:
          break;
      }
    };

    const payload = {
      title: title(),
      contents: JSON.stringify(quillRef.current?.getContents()),
      type: type,
    };
    if (html) {
      await updateTerms({
        ...payload,
        id: id,
      });
    } else {
      await addTerms(payload);
    }
    onSubmit();
  };

  return (
    <div className="-mt-3">
      <div className="flex items-center justify-between">
        <div className="flex">
          {editMode ? (
            <Modal
              description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
              onSubmit={onEditSubmit}
            >
              <Button width="w-24" text="입력취소" />
            </Modal>
          ) : (
            <Button onClick={onEdit} width="w-24" text="수정" />
          )}
          {editMode && (
            <Modal
              description={
                <span>
                  입력한 정보로 저장하시겠습니까? <br />
                  저장된 정보는 회원의 정책, 약관 표시 영역에 연동됩니다.
                </span>
              }
              onSubmit={handleSubmit}
            >
              <Button
                type="button"
                isDisabled={isDisabled}
                width="w-24"
                bgColor="bg-primary-blue"
                textColorDefault="text-white"
                text={`등록완료`}
              />
            </Modal>
          )}
        </div>
        <span>
          업데이트 일시 : {dayjs(updatedAt).format("YYYY-MM-DD HH:mm")}
        </span>
      </div>
      <div className="mt-4">
        {!editMode ? (
          <EditorViewer
            delta={parsedDelta}
            className="border text-[12px] border-primary-grey mt-4 px-2 py-2.5 min-h-[300px] overflow-auto"
          />
        ) : (
          <Editor
            ref={quillRef}
            defaultValue={parsedDelta}
            onTextChange={onTextChange}
          />
        )}
      </div>
    </div>
  );
};

export default TermsConditions;
